import { memo } from 'react';
import { FiSearch } from 'react-icons/fi';

import { OButton, OCheck, OModal } from '@src/shared';

import styles from './InviteToMagicPenModal.module.scss';
import useInviteToMagicPenModal from './useInviteToMagicPenModal';
import AvatarCircle from '../AvatarCircle';

const InviteToMagicPenModal = () => {
  const {
    isInviteToMagicPenModal,
    handleClose,
    selectedCount,
    allVisibleSelected,
    someVisibleSelected,
    handleSummaryCheck,
    allowAll,
    filteredUser,
    setQuery,
    selected,
    toggleOne,
    handleUpdate,
    query,
    isLoading,
  } = useInviteToMagicPenModal();
  const isEmpty = filteredUser.length === 0;

  return (
    <OModal
      isOpen={isInviteToMagicPenModal}
      onClose={handleClose}
      hasBackdrop
      classes={{ container: `${styles.inviteToMagicPenModal}`, closeIcon: `${styles.close}`, body: styles.oModalBody }}
    >
      <div className={styles.body}>
        <div className={styles.header}>
          <p className={styles.title}>Let others annotate</p>
        </div>

        <div className={styles.search}>
          <FiSearch size={18} aria-hidden />
          <input
            id="annotate-search"
            type="text"
            placeholder="Find someone"
            value={query}
            autoComplete="off"
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        <div className={styles.summary}>
          <span className={styles.count}>
            {selectedCount} {selectedCount === 1 ? 'person' : 'persons'} selected
          </span>

          {isEmpty ? (
            <span className={styles.fakeCheck} aria-hidden="true" />
          ) : (
            <OCheck
              checked={allVisibleSelected}
              indeterminate={someVisibleSelected}
              onChange={handleSummaryCheck}
              disabled={allowAll}
              ariaLabel="Select all (filtered)"
              className={styles.summaryCheck}
            />
          )}
        </div>

        <div className={styles.list}>
          {isLoading ? (
            <div className={styles.empty}>Loading permissions...</div>
          ) : (
            <>
              {filteredUser.map((peer) => {
                const checked = allowAll ? true : selected.has(peer.id);
                const isHostOrScreenSharer = peer.isHost || peer.isScreenSharer;
                const isDisabled = allowAll || isHostOrScreenSharer;

                return (
                  <div className={`${styles.row} ${isHostOrScreenSharer ? styles.disabled : ''}`} key={peer.id}>
                    <div className={styles.info}>
                      <AvatarCircle peerId={peer?.id} avatarImgSize={36} name={peer.name} />

                      <span className={styles.name} title={peer.name}>
                        {peer.name}
                      </span>
                    </div>
                    <div className={styles.checkboxContainer}>
                      {peer.isHost && !peer.isActingHost && <span className={styles.roleLabel}>(Host)</span>}
                      {peer.isActingHost && <span className={styles.roleLabel}>(Co-Host)</span>}
                      {!peer.isHost && peer.isScreenSharer && (
                        <span className={styles.roleLabel}>(Screen Sharer)</span>
                      )}
                      <OCheck
                        checked={checked}
                        onChange={(v: boolean) => toggleOne(peer.id, v)}
                        disabled={isDisabled}
                        aria-label={`toggle ${peer.name}`}
                      />
                    </div>
                  </div>
                );
              })}

              {isEmpty && <div className={styles.empty}>No person match .</div>}
            </>
          )}
        </div>

        <div className={styles.footer}>
          <OButton
            text="Cancel"
            size="medium"
            onClick={handleClose}
            classes={{ container: 'btn-cancel' }}
            outlined
            variant="cancel"
            disabled={isLoading}
          />
          <OButton
            text="Update"
            size="medium"
            onClick={handleUpdate}
            classes={{ container: 'btn-update' }}
            disabled={isLoading}
          />
        </div>
      </div>
    </OModal>
  );
};

export default memo(InviteToMagicPenModal);
